var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Match from './Match';
import * as languages from '../../../constants/Language';
var monthNamesEn = [
    'January', 'February', 'March',
    'April', 'May', 'June', 'July',
    'August', 'September', 'October',
    'November', 'December'
];
var monthNamesRu = [
    'Январь', 'Февраль', 'Март',
    'Апрель', 'Май', 'Июнь', 'Июль',
    'Август', 'Сентябрь', 'Октябрь',
    'Ноябрь', 'Декабрь'
];
var monthNamesUz = [
    'Yanvar', 'Fevral', 'Mart',
    'Aprel', 'May', 'Iyun', 'Iyul',
    'Avgust', 'Sentyabr', 'Oktyabr',
    'Noyabr', 'Dekabr'
];
var monthNamesKk = [
    'Қаңтар', 'Ақпан', 'Наурыз',
    'Сәуір', 'Мамыр', 'Маусым', 'Шілде',
    'Тамыз', 'Қыркүйек', 'Қазан',
    'Қараша', 'Желтоқсан'
];
function matchSortFunc(a, b) {
    if (a.startDate > b.startDate) {
        return 1;
    }
    else if (a.startDate < b.startDate) {
        return -1;
    }
    var compare = a.sportPriority - b.sportPriority;
    if (compare === 0) {
        compare = a.leaguePriority = b.leaguePriority;
        if (compare === 0) {
            return a.name.localeCompare(b.name);
        }
    }
    return compare;
}
function renderMatch(match, props) {
    var matchId = match.id;
    return (_jsx(Match, __assign({ id: matchId }, props), matchId));
}
function getMonthNames(languageId) {
    if (languageId === languages.RU)
        return monthNamesRu;
    if (languageId === languages.UZ)
        return monthNamesUz;
    if (languageId === languages.KK)
        return monthNamesKk;
    return monthNamesEn;
}
function formatDate(date, languageId) {
    var newDate = new Date(date);
    var monthNames = getMonthNames(languageId);
    return newDate.getDate() + ' ' + monthNames[newDate.getMonth()] + ' ' + newDate.getFullYear();
}
var MatchGroup = function (props) {
    var matches = props.matches, matchIds = props.matchIds, gridLocalization = props.gridLocalization, section = props.section, leagueName = props.leagueName, sportCssName = props.sportCssName, languageId = props.languageId;
    var mdate = props.mdate.replace(/-/g, '/');
    var startDate;
    var sortedMatches = [];
    for (var i = 0; i < matchIds.length; i++) {
        var matchId = matchIds[i];
        var match = matches.get(matchId);
        if (match) {
            startDate = match.get('startDate');
            var notice = match.get('notice') || null;
            var name = match.get('name');
            if (notice !== null) {
                name = name + ' (' + notice + ')';
            }
            sortedMatches.push({
                id: matchId,
                startDate: startDate,
                name: name,
            });
        }
    }
    sortedMatches.sort(matchSortFunc);
    var matchProps = {
        gridLocalization: gridLocalization,
        section: section,
        leagueName: leagueName,
        sportCssName: sportCssName
    };
    return (_jsxs("div", __assign({ className: 'item' }, { children: [_jsx("div", __assign({ className: 'title' }, { children: formatDate(mdate, languageId) })), _jsx("div", __assign({ className: 'lines' }, { children: sortedMatches.map(function (m) { return renderMatch(m, matchProps); }) }))] })));
};
MatchGroup.propTypes = {
    matches: PropTypes.object.isRequired,
    matchIds: PropTypes.array.isRequired,
    leagueName: PropTypes.string.isRequired,
    sportCssName: PropTypes.string.isRequired,
    languageId: PropTypes.number.isRequired,
};
export default MatchGroup;



// WEBPACK FOOTER //
// ./src/components/info/results/MatchGroup.jsx